import React, { Component } from 'react';
import TabBarView from '../component/TabBarView';
import QuestionTabView from '../component/maincomponent/QuestionTabView';
import RoleTabView from '../component/maincomponent/RoleTabView';
import MineTabView from '../component/maincomponent/MineTabView';


class MainContentView extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showControl : 1
    };
  }

  componentDidMount() {
    // 每日登录奖励（非首次注册当日）
    if (this.props.onMount) {
      this.props.onMount();
    }
  }

 clickTabAction = (index) =>{
    console.log('clickTabBar', index);

    if (this.state.showControl === index) {
      return;
    }

    this.setState({ showControl: index})
 }

  render() {
    return (
      <div>
        {this.state.showControl === 1 && <QuestionTabView></QuestionTabView>}
        {this.state.showControl === 2 && <RoleTabView></RoleTabView>}
        {this.state.showControl === 3 && <MineTabView></MineTabView>}
        <TabBarView onClick={this.clickTabAction}></TabBarView>
      </div>
    );
  }
}

export default MainContentView;